import { __decorate } from 'tslib';
import { ViewChild, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { AbstractTuiPortalHostComponent, AbstractTuiPortalService } from '@taiga-ui/cdk/abstract';
import { TuiPortalService } from '@taiga-ui/cdk/components/portal-host';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["positionFixedOffset"];
const _c1 = ["*"];
const BLANK_CLIENT_RECT = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
};
/**
 * Host element for dynamically created portals, for example using {@link TuiDropdownDirective}.
 */
let TuiDropdownHostComponent = class TuiDropdownHostComponent extends AbstractTuiPortalHostComponent {
    fixedPositionOffset() {
        var _a;
        return (((_a = this.positionFixedOffsetRef) === null || _a === void 0 ? void 0 : _a.nativeElement.getBoundingClientRect()) ||
            BLANK_CLIENT_RECT);
    }
};
TuiDropdownHostComponent.ɵfac = /*@__PURE__*/ function () { let ɵTuiDropdownHostComponent_BaseFactory; return function TuiDropdownHostComponent_Factory(t) { return (ɵTuiDropdownHostComponent_BaseFactory || (ɵTuiDropdownHostComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiDropdownHostComponent)))(t || TuiDropdownHostComponent); }; }();
TuiDropdownHostComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiDropdownHostComponent, selectors: [["tui-dropdown-host"]], viewQuery: function TuiDropdownHostComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.positionFixedOffsetRef = _t.first);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractTuiPortalService, useExisting: TuiPortalService }]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 5, vars: 0, consts: [[1, "position-fixed-offset"], ["positionFixedOffset", ""], ["viewContainer", ""]], template: function TuiDropdownHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementContainer(3, null, 2);
    } }, styles: ["[_nghost-%COMP%]{position:relative;z-index:0;display:block;height:100%}[_nghost-%COMP%]:before{content:'';display:block;overflow:hidden}.position-fixed-offset[_ngcontent-%COMP%]{position:fixed;left:0;top:0;pointer-events:none;visibility:hidden;width:100%;height:100%}"], changeDetection: 0 });
__decorate([
    ViewChild('positionFixedOffset')
], TuiDropdownHostComponent.prototype, "positionFixedOffsetRef", void 0);

let TuiDropdownHostModule = class TuiDropdownHostModule {
};
TuiDropdownHostModule.ɵfac = function TuiDropdownHostModule_Factory(t) { return new (t || TuiDropdownHostModule)(); };
TuiDropdownHostModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiDropdownHostModule });
TuiDropdownHostModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDropdownHostComponent, [{
        type: Component,
        args: [{
                selector: 'tui-dropdown-host',
                template: "<div\n    #positionFixedOffset\n    class=\"position-fixed-offset\"\n></div>\n<ng-content></ng-content>\n<ng-container #viewContainer></ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [{ provide: AbstractTuiPortalService, useExisting: TuiPortalService }],
                styles: [":host{position:relative;z-index:0;display:block;height:100%}:host:before{content:'';display:block;overflow:hidden}.position-fixed-offset{position:fixed;left:0;top:0;pointer-events:none;visibility:hidden;width:100%;height:100%}"]
            }]
    }], null, { positionFixedOffsetRef: [{
            type: ViewChild,
            args: ['positionFixedOffset']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDropdownHostModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiDropdownHostComponent],
                exports: [TuiDropdownHostComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDropdownHostModule, { declarations: [TuiDropdownHostComponent], exports: [TuiDropdownHostComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDropdownHostComponent, TuiDropdownHostModule };

